<!-- <app-navbar-auth></app-navbar-auth> -->
<div class="wrapper">
    <router-outlet></router-outlet>
    <!-- <img src="./assets/img/uloans/backg.png" style="margin-top:-821px; margin-left: -372px;"> -->
</div>